import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    Skeleton,
    Stack,
    Typography,
} from "@mui/material";
import { FileProvider, useFileContext } from "context/FilesV2";
import {
    formatFiles,
    downloadFile,
    uploadFiles,
    deleteFile,
    deleteBundle,
} from "util";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { FileGroup } from "common/FileUpload";
import { getFiles } from "apis/controllers/files";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import { Attachment, Sync } from "@mui/icons-material";

const FilesUpload = forwardRef(
    ({ fileGroups, id, settings = {}, dataKey, dataValue }, ref) => {
        const { fileGroups: fileGroupsV2, control: filesControl } =
            useFileContext();

        useImperativeHandle(ref, () => ({
            uploadFiles: async () => {
                await filesControl.uploadFileGroups();
            },
            filebundles: {
                dataKey: dataKey,
                dataValue: dataValue,
                files: fileGroupsV2?.flatMap((group) => group?.bundles),
            },
        }));

        useEffect(() => {
            try {
                const formattedFiles = formatFiles(fileGroups);
                if (formattedFiles !== undefined) {
                    filesControl.initialize(formattedFiles);
                } else {
                    filesControl.initialize([]);
                }
            } catch (error) {
                console.error("error", error);
            }

            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [fileGroups]);
        return (
            <>
                {fileGroupsV2?.map((group, index) => (
                    <FileGroup
                        reviewMode={false}
                        isReadOnly={false}
                        canAdd={true}
                        key={group.id}
                        id={group.id}
                        title={group?.title}
                        maxSize={5242880}
                        maxFiles={5}
                        maxBundles={1}
                        fields={group.fields}
                        bundles={group?.bundles}
                        templates={group?.templates}
                        canViewReview={settings?.canViewReview}
                        forceHideNotFound={true}
                    />
                ))}
            </>
        );
    }
);

const AttachmentConfig = (
    props,
    ref
) => {
    const { id, dataKey, dataValue, settings = {} } = props;
    const { t } = useTranslation();
    const filesQuery = useQuery(
        ["paymentFiles", id, props.dataValue, props.dataKey],
        async ({ queryKey }) => {
            const [, id, dataValue] = queryKey;

            const getFilesRequest = {
                DataKey: dataKey,
                DataValue: dataValue,
                RecordId: null,
                RecordGuid: null,
                ProjectTableId: 19,
                applyRules: false,
            };
            const files = await getFiles(getFilesRequest);
            return files?.data;
        }
    );

    return {
        loading: <Skeleton />,
        success:
            filesQuery?.data?.length === 0 ? null : (

                <FileProvider
                    downloadFile={(fileId, type) => downloadFile(fileId, type)}
                    uploadFiles={(fileGroups) => uploadFiles(fileGroups, null)}
                    onDeleteBundle={async (bundleId) =>
                        await deleteBundle(bundleId, 19, null, id, null)
                    }
                    onDeleteFile={async (fileId) =>
                        await deleteFile(fileId, 19, null, id === "0" ? null : id, null)
                    }
                >

                    <FilesUpload
                        fileGroups={filesQuery?.data}
                        ref={ref}
                        id={id}
                        settings={settings}
                        dataKey={dataKey}
                        dataValue={dataValue}
                    />
                </FileProvider>

            ),
        error: <>Error fetching required attachments</>,
    }[filesQuery?.status];
};

export default forwardRef(AttachmentConfig);
